import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { reportColumnAggregateTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import mean from "lodash/mean";
import sum from "lodash/sum";
import Tooltip from "rc-tooltip";
import React from "react";
import { list as logistsList } from "sources/books/employees";
import GroupedByLogistReport from "./groupedByLogistReport";

export default class ExcessMileageReport extends GroupedByLogistReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const { car } = props.row.values;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: car };
                switch (props.column.id) {
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName = subRows[0].original?.carLogistDisplayName || "Без логиста";
                        const rowCount = /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return (
                            <span data-car-logist-id={props.value}>
                                {logistName}
                                {rowCount}
                            </span>
                        );
                    }
                    case "bidId": {
                        const { secondaryDriverId, secondaryDriverFullName, hasEmulatedMileage } = props.row.original;
                        return (
                            <>
                                <a
                                    data-bidid={props.value}
                                    href={paths.bidShow("bid", props.value)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {props.value}
                                </a>
                                {secondaryDriverId && (
                                    <Tooltip
                                        overlay={
                                            <div>
                                                <b>Парный экипаж</b>
                                                <br />
                                                Второй водитель: {secondaryDriverFullName}
                                            </div>
                                        }
                                        overlayClassName="notifys__tooltip"
                                        placement="bottom"
                                    >
                                        <i className="icon-uEAC2-user-group b-table__compound-icon pl-1" />
                                    </Tooltip>
                                )}
                                {hasEmulatedMileage && (
                                    <Tooltip overlay="В заявке присутствуют сэмулированные участки маршрута">
                                        <i className="pl-1 icon-uEACB-emulated-route b-point__tooltip-icon" />
                                    </Tooltip>
                                )}
                            </>
                        );
                    }
                    default:
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value, column.clrType)}
                            </div>
                        );
                }
            },
            ...typeSpecificProps(column),
            aggregate: (leafValues) => {
                if (!this.numericClrTypes.includes(column.clrType)) {
                    return null;
                }
                switch (column.aggregateType) {
                    case reportColumnAggregateTypesEnum.Average:
                        return Math.round(mean(leafValues));
                    case reportColumnAggregateTypesEnum.Sum:
                        return sum(leafValues);
                    default:
                        return null;
                }
            },
            Aggregated: ({ value }) => {
                return value !== null ? <strong>{formatValue(value, column.clrType)}</strong> : "";
            },
            ...(column.propertyName === "CarLogistId"
                ? {
                      Filter: reportFilterWrapper((props) => (
                          <SelectColumnFilter
                              {...props}
                              selectProps={{
                                  ...defaultMultipleSelectProps,
                                  url: logistsList,
                                  inputProps: { name: "carLogistIds" },
                                  propName: "fullNameOrEmail",
                                  components: { ValueContainer },
                              }}
                          />
                      )),
                      filter: (rows, _id, filterValue) => {
                          if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                              return rows;
                          }
                          return rows.filter((row) => filterValue.value.includes(row.values.carLogistId));
                      },
                  }
                : {}),
        };
    };
}
